<template>

  <div>

    <b-modal v-model="hasGeneralErrors" id="modalGeneralErrors" no-close-on-esc no-close-on-backdrop
             title="Erros encontrados:" ok-only>




      <div v-for="error in generalErrors" :key="error" class="p-2 border-bottom mb-2">
        <span class="text-danger">
          <b-icon-x-circle-fill class="mr-2"/>
          <span v-html="error.replace(/\n/g,'<br />')"></span>
        </span>
      </div>

      <template #modal-footer="{ ok }">

        <t-button @click="ok()" text="Corrigir Erros" danger/>

      </template>

    </b-modal>

    <!--no-close-on-esc necessário para não conflitar com esc de inputs ou outros dialogos sobrepostos-->
    <b-modal
        :id="id"
        ref="modal"
        :title="title"
        cancel-title="Cancelar"
        :size="large ? 'lg' : 'md'"
        :busy="busy"
        no-close-on-backdrop
        no-close-on-esc
        no-enforce-focus
        @show="onShow"
        @hidden="onHidden"
        @cancel="handleCancel"
        @ok="handleOk">


      <div v-if="tabs">

        <slot name="header-tab"></slot>

        <b-tabs id="dialog-form-tabs" v-model="tabIndex" ref="containerTabs"
                content-class="mt-3" class="tabs-form" align="left">


          <validation-observer ref="validation" v-slot="{invalid,errors}">

              <span class="display-none">
                {{ errorList = errors }}
                {{ isInvalid = invalid }}
              </span>

            <form @submit.prevent="onSubmit" autocomplete="off" ref="form" :class="{'form-loading':busy}">

              <t-form-wrapped :command="command" :status="localStatus">
                <slot :status="localStatus"></slot>
              </t-form-wrapped>

            </form>

          </validation-observer>

          <slot name="out-of-form"></slot>

        </b-tabs>

      </div>

      <div v-else>

        <validation-observer ref="validation">

          <form @submit.prevent="onSubmit" autocomplete="off" ref="form" :class="{'form-loading':busy}">

            <t-form-wrapped :command="command" :status="localStatus">
              <slot :status="localStatus"></slot>
            </t-form-wrapped>

          </form>

        </validation-observer>

        <slot name="out-of-form"></slot>

      </div>


      <template #modal-footer="{ok,cancel}">

        <div class="d-flex w-100 justify-content-between ml-3 mr-3">
          <t-button @click="cancel()" :text="localCancelText" :sending="onSending"
                    v-show="!hideSubmit && localCancelText !== ''" outline-secondary/>

          <slot name="add-buttons"></slot>

          <t-button @click="ok()" class="pr-5 pl-5" :disabled="disabledSubmit" v-show="!hideSubmit" :text="localOkText"
                    :sending="onSending"
                    submit
                    :primary="localVariant === 'primary'"
                    :success="localVariant === 'success'"
                    :warning="localVariant === 'warning'"
                    :danger=" localVariant === 'danger'"/>
        </div>

      </template>

    </b-modal>

  </div>


</template>
<script>
import ui from "@/assets/scripts/ui";

export default {
  name: 't-dialog-form',
  data() {
    return {
      hasGeneralErrors: false,
      localStatus: "",
      localOkText: "",
      localVariant: "",
      localCancelText: "Cancelar",
      size: "md",
      errorList: [],
      isInvalid: false,
      tabIndex: 0,
    }
  },
  props: {
    generalErrors: Array,
    id: String,
    title: String,
    status: String,
    hideSubmit: Boolean,
    disabledSubmit: Boolean,
    large: {
      type: Boolean,
      default: false
    },
    tabs: {
      type: Boolean,
      default: false,
    },
    cancelText: {
      type: String,
      default: 'Cancelar'
    },
    okText: {
      type: String,
      default: 'Incluir'
    },
    command: {
      type: String,
      default: 'insert'
    },
    variant: {
      type: String,
      default: 'primary'
    },
    busy: {//busy principal
      type: Boolean,
      default: false,
    },
    setTabIndex: {
      type: Number,
      default: 0,
    }
  },
  mounted() {
    this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    this.localStatus = this.status
    this.localOkText = this.okText
    this.localVariant = this.variant
    this.localCancelText = this.cancelText
    this.tabIndex = this.setTabIndex

  },
  computed: {
    onStatus() {
      return this.status
    },
    onSending() {
      return this.status === "sending"
    },
  },
  methods: {

    onShow() {
      this.$emit('show')
    },
    onHidden() {
      this.$emit('hidden')
    },
    handleCancel() {
      this.$emit('onCancel')

    },
    handleOk(bvModalEvt) {

      bvModalEvt.preventDefault()
      this.onSubmit()

    },
    setReset() {

    },
    onSubmit() {

      //Avisa o pai que mudou o status para submetido
      this.localStatus = "subject"
      this.$parent.status = "subject"

      this.$refs.validation.validate().then(success => {

        if (!success) {
          ui.msgErrorForm(this, this.$refs.validation)
          return;
        }

        //console.log('Form validação básica padrão passou!')

        this.$emit('onSubmit')


      });

    },
    checkValidation() {
      //return ui.hasValidation(this.command,this.userAuth.validation)

      return ((this.command === 'insert' && this.userAuth.validation.validationCreate) ||
          (this.command === 'update' && this.userAuth.validation.validationUpdate) ||
          (this.command === 'delete' && this.userAuth.validation.validationDelete) ||
          (this.command === "view" && this.userAuth.validation.validationRead))

    },

  },
  watch: {
    status(value) {
      this.localStatus = value
    },
    okText(value) {
      this.localOkText = value
    },
    variant(value) {
      this.localVariant = value
    },
    generalErrors() {
      this.hasGeneralErrors = this.generalErrors && this.generalErrors.length > 0
    },
    setTabIndex(value) {
      this.tabIndex = value
    },
  }
}
</script>
